/* GOMYART — GM · Bestsellers: colour dots switch photo, price and link. No dependencies. */
(function () {
  if (window.__gmBs) return; window.__gmBs = true;

  function pick(btn) {
    var card = btn.closest('[data-gm-bs-card]'); if (!card) return;
    card.querySelectorAll('.gm-bs__sw').forEach(function (b) {
      var on = b === btn; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var img = card.querySelector('[data-gm-bs-img]');
    if (img && btn.dataset.img && img.getAttribute('src') !== btn.dataset.img) {
      img.classList.add('is-swapping');
      var next = new Image();
      next.onload = next.onerror = function () {
        img.srcset = btn.dataset.srcset || ''; img.src = btn.dataset.img; img.classList.remove('is-swapping');
      };
      next.src = btn.dataset.img;
    }
    var link = card.querySelector('[data-gm-bs-link]'); if (link && btn.dataset.url) link.href = btn.dataset.url;
    var price = card.querySelector('[data-gm-bs-price]'); if (price && btn.dataset.price) price.innerHTML = btn.dataset.price;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.gm-bs__sw'); if (!btn) return;
    e.preventDefault(); pick(btn);
  });

  /* warm the variant photos when a card is first approached */
  function warm(card) {
    if (card.__gmWarm) return; card.__gmWarm = true;
    card.querySelectorAll('.gm-bs__sw[data-img]').forEach(function (b) { var i = new Image(); i.src = b.dataset.img; });
  }
  document.addEventListener('pointerover', function (e) { var c = e.target.closest && e.target.closest('[data-gm-bs-card]'); if (c) warm(c); }, { passive: true });
  document.addEventListener('focusin', function (e) { var c = e.target.closest && e.target.closest('[data-gm-bs-card]'); if (c) warm(c); });
})();
